// extracted by mini-css-extract-plugin
module.exports = {"root":"EasyImageCrop_root__eROZC","container":"EasyImageCrop_container__qPV_3"};